import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import {
  Stack,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormLabel,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  ToggleButton,
  Tooltip,
  Button,
  FormHelperText,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { PreLoader } from "../../subcomponents/Preloader";
import { textStyle } from "../../styles/Style";
import "../../../components/styles/popupStyle.css";
import { phoneTypes } from "../../../constants/PhoneTypes";
import { Languages } from "../../../constants/languages";
import {
  validateEmail,
  validatePhoneNumber,
  validationMessages,
} from "../../actions/validations";
import { YesOrNo } from "../../../constants/YesOrNo";
import { ArrowDropDownIcon } from "@mui/x-date-pickers/icons";
import InfoIcon from "@mui/icons-material/Info";
import { tooltipComponent } from "../../subcomponents/tooltipComponent";
import {
  validateString,
  validationLength,
  validationType,
} from "../../actions/validations";
import DraggableItemList from "../../subcomponents/DNDComponent";
import { buttonValues, DNDFieldsEnum } from "../../../constants/Types";
import {
  checkData,
  checkDuplicate,
  deleteItem,
  updateData,
} from "../../actions/actionItems";
import { GolfPropertyEnum } from "../../../constants/NavbarList";
import { Guarantee } from "../../../constants/GuaranteeField";
import { golfTooltipHeaders } from "../../../constants/TooltipInformation";
import { ClearButton } from "../../subcomponents/ClearButton";
import { CopyButton } from "../../subcomponents/CopyButton";
import AlertComponent from "../../subcomponents/AlertComponent";

const GolfRateTypes = ({
  data,
  fieldValues,
}: {
  data: any;
  fieldValues: any;
}) => {
  const [hole9, set9hole] = useState<boolean>(false);
  const [daysOutStart, setDaysOutStart] = useState<Number | null>(null);
  const [daysOutEnd, setDaysOutEnd] = useState<Number | null>(null);
  const [active, setActive] = useState<boolean>(true);
  const [availableOnWeb, setAvailableOnWeb] = useState<boolean>(false);
  const [rateType, setRateType] = useState<string | null>(null);
  const [supressOnReceipt, setSupressOnReceipt] = useState<boolean>(false);
  const [minPlayers, setMinPlayers] = useState<Number | null>(null);
  const [guarantee, setGuarantee] = useState<boolean>(false);
  const [noneField, setNoneField] = useState<boolean>(false);
  const [member, setMember] = useState<boolean>(false);
  const [resort, setResort] = useState<boolean>(false);
  const [creditCard, setCreditCard] = useState<boolean>(false);
  const [nameError, setNameError] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [GolfRateTypes, setGolfRateTypes] = useState<any>([]);
  const [editClicked, setEditClicked] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const [lastUpdatedRecord, setLastUpdatedRecord] = useState<any>(null);

  const validateInput = () => {
    if (!rateType) {
      setAlertMessage("Rate type is mandatory");
      setAlertType("error");
      setOpenAlert(true);
      return false;
    }
    setNameError(false);
    if (
      rateType &&
      !validateString(rateType, validationLength.rateType, validationType.SPACE)
    ) {
      setNameError(true);
      return false;
    }
    return true;
  };

  // useEffect(() => {
  //   validateInput();
  // }, [rateType]);

  const updateGolfRateTypes = () => {
    if (!validateInput()) {
      return;
    }
    if (
      checkDuplicate(
        (GolfRateTypes ?? []).filter(
          (item: any) => String(item.id) !== String(selectedId),
        ),
        DNDFieldsEnum.RATETYPE,
        rateType,
      )
    ) {
      setAlertMessage("Cannot have duplicate entries");
      setAlertType("error");
      setOpenAlert(true);
      return;
    }
    setNameError(false);
    setGolfRateTypes((prev: any) => {
      return (prev ?? []).map((item: any) => {
        if (item.id === selectedId) {
          return {
            ...item,
            ...payload,
          };
        }
        return item;
      });
    });
    editGolfRateTypes(null);
    setEditClicked(false);
    setSelectedId(null);
    setAlertMessage(`${GolfPropertyEnum.rateTypes} updated successfully`);
    setAlertType("success");
    setOpenAlert(true);
  };

  const addGolfRateTypes = () => {
    if (!validateInput()) {
      return;
    }
    if (checkDuplicate(GolfRateTypes ?? [], DNDFieldsEnum.RATETYPE, rateType)) {
      setAlertMessage("Cannot have duplicate entries");
      setAlertType("error");
      setOpenAlert(true);
      return;
    }
    setGolfRateTypes((prev: any) => {
      return updateData(
        prev?.length
          ? [
              ...prev,
              {
                id: (prev?.length ?? 0) + 1,
                ...payload,
              },
            ]
          : [
              {
                id: 1,
                ...payload,
              },
            ],
      );
    });
    setLastUpdatedRecord(payload);
    editGolfRateTypes(null);
    setEditClicked(false);
  };

  const editGolfRateTypes = (list: any) => {
    list?.id && setSelectedId(list.id);
    list !== null && setEditClicked(true);
    setRateType(list?.["Rate Type"]);
    setDaysOutStart(list?.["Days Out Start"]);
    setDaysOutEnd(list?.["Days out End"]);
    setGuarantee(list?.["Guarantee"]);
    setActive(list?.["Active"]);
    setSupressOnReceipt(list?.["Suppress on Receipt"]);
    set9hole(list?.["9 Hole"]);
    setAvailableOnWeb(list?.["Available on Web"]);
    setMinPlayers(list?.["Min # Players"]);
  };

  const deleteGolfRateTypes = (id: number) => {
    setGolfRateTypes(deleteItem(GolfRateTypes ?? [], id));
  };

  useEffect(() => {
    fieldValues && setGolfRateTypes(fieldValues);
  }, []);

  useEffect(() => {
    data(GolfRateTypes);
    editClicked &&
      setSelectedId(checkData(GolfRateTypes, selectedId) ? selectedId : null);
  }, [GolfRateTypes]);

  const payload = {
    "Rate Type": rateType,
    "Days Out Start": daysOutStart,
    "Days out End": daysOutEnd,
    Guarantee: guarantee,
    Active: active,
    "Suppress on Receipt": supressOnReceipt,
    "9 Hole": hole9,
    "Available on Web": availableOnWeb,
    "Min # Players": minPlayers,
  };

  return (
    <Stack>
      <Paper
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          padding: "20px",
        }}
      >
        <Stack direction="row" width="100%" justifyContent="space-between">
          <Typography variant="h6" component="div" sx={textStyle}>
            Rate Types
            <Tooltip
              title={tooltipComponent(golfTooltipHeaders.rateTypesHeaders)}
            >
              <InfoIcon fontSize="small" />
            </Tooltip>
          </Typography>
          <Stack direction="row" gap="10px" justifyContent="space-between">
            {editClicked && (
              <ClearButton
                click={() => {
                  editGolfRateTypes(null);
                  setSelectedId(null);
                }}
              />
            )}
            {lastUpdatedRecord && (
              <CopyButton
                click={() => {
                  editGolfRateTypes(lastUpdatedRecord);
                }}
              />
            )}
          </Stack>
        </Stack>
        <Stack>
          <FormLabel component="legend">
            Rate Type
            <Tooltip title={tooltipComponent(golfTooltipHeaders.rateType)}>
              <InfoIcon fontSize="small" />
            </Tooltip>
          </FormLabel>
          <TextField
            id="rateType"
            variant="outlined"
            placeholder="Rate Type"
            value={rateType ?? ""}
            helperText={nameError ? validationMessages.rateType : ""}
            error={nameError}
            onChange={(e: any) => {
              setRateType(e.target.value);
            }}
          />
        </Stack>
        <Stack>
          <FormLabel component="legend">
            Days Out Start
            <Tooltip title={tooltipComponent(golfTooltipHeaders.daysOutStart)}>
              <InfoIcon fontSize="small" />
            </Tooltip>
          </FormLabel>
          <TextField
            id="daysOutStart"
            variant="outlined"
            placeholder="Days Out Start"
            value={daysOutStart ?? ""}
            type="number"
            onChange={(e: any) => {
              setDaysOutStart(e.target.value);
            }}
          />
        </Stack>
        <Stack>
          <FormLabel component="legend">
            Days Out End
            <Tooltip title={tooltipComponent(golfTooltipHeaders.daysOutEnd)}>
              <InfoIcon fontSize="small" />
            </Tooltip>
          </FormLabel>
          <TextField
            id="daysOutEnd"
            variant="outlined"
            placeholder="Days Out End"
            value={daysOutEnd ?? ""}
            type="number"
            onChange={(e: any) => {
              setDaysOutEnd(e.target.value);
            }}
          />
        </Stack>
        <Stack>
          <FormLabel component="legend">
            Guarantee
            <Tooltip
              title={tooltipComponent(golfTooltipHeaders.guaranteeRateType)}
            >
              <InfoIcon fontSize="small" />
            </Tooltip>
          </FormLabel>{" "}
          <Select
            id="guarantee"
            value={guarantee ?? ""}
            onChange={(e: any) => setGuarantee(e.target.value)}
            sx={{ width: "100%" }}
          >
            {Guarantee.map((type: any, index: any) => (
              <MenuItem placeholder="Active" value={type} key={index}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </Stack>

        <Stack direction="row" gap="2px">
          <FormControlLabel
            control={
              <Switch checked={active} onChange={() => setActive(!active)} />
            }
            label="Active"
          />
          <Tooltip title={tooltipComponent(golfTooltipHeaders.active)}>
            <InfoIcon fontSize="small" />
          </Tooltip>
        </Stack>
        <Stack direction="row" gap="2px">
          <FormControlLabel
            control={
              <Switch
                checked={supressOnReceipt}
                onChange={() => setSupressOnReceipt(!supressOnReceipt)}
              />
            }
            label="Suppress on Receipt?"
          />
          <Tooltip
            title={tooltipComponent(golfTooltipHeaders.suppressOnReceipt)}
          >
            <InfoIcon fontSize="small" />
          </Tooltip>
        </Stack>
        <Stack direction="row" gap="2px">
          <FormControlLabel
            control={
              <Switch checked={hole9} onChange={() => set9hole(!hole9)} />
            }
            label="9 Hole?"
          />
          <Tooltip title={tooltipComponent(golfTooltipHeaders.hole9)}>
            <InfoIcon fontSize="small" />
          </Tooltip>
        </Stack>
        <Stack direction="row" gap="2px">
          <FormControlLabel
            control={
              <Switch
                checked={availableOnWeb}
                onChange={() => {
                  setAvailableOnWeb(!availableOnWeb);
                  if (availableOnWeb) {
                    setMinPlayers(null);
                  }
                }}
              />
            }
            label="Available on Web?"
          />
          <Tooltip
            title={tooltipComponent(golfTooltipHeaders.availableOnWebRateType)}
          >
            <InfoIcon fontSize="small" />
          </Tooltip>
        </Stack>
        {availableOnWeb && (
          <Stack>
            <FormLabel component="legend">
              Minimum Players
              <Tooltip title={tooltipComponent(golfTooltipHeaders.minPlayers)}>
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="minPlayers"
              variant="outlined"
              placeholder="Minimum Players"
              value={minPlayers ?? ""}
              type="number"
              onChange={(e: any) => {
                setMinPlayers(e.target.value);
              }}
            />
          </Stack>
        )}
        <Stack direction="row" width="100%" justifyContent="flex-end">
          <Button
            variant="contained"
            sx={{
              cursor: "pointer",
              border: "1px solid gray",
              borderRadius: "10px",
              background: "darkgreen",
              color: "white",
            }}
            onClick={() =>
              selectedId ? updateGolfRateTypes() : addGolfRateTypes()
            }
          >
            {selectedId ? buttonValues.UPDATE : buttonValues.ADD}
            Rate Type
          </Button>
        </Stack>
        <Stack direction="column" gap="10px" mt={4}>
          <Typography variant="body2" sx={{ color: "red", fontWeight: 800 }}>
            Do not use sample data. Those are for demo purposes only!
          </Typography>
          <Typography variant="h6">Rate Types Available</Typography>
          <Stack direction="column" gap="10px">
            {GolfRateTypes ? (
              <DraggableItemList
                itemData={GolfRateTypes}
                onOrderUpdate={(order) => setGolfRateTypes(order)}
                onEdit={(info) => editGolfRateTypes(info)}
                onDelete={(id) => deleteGolfRateTypes(id)}
                code={DNDFieldsEnum.RATETYPE}
                name={DNDFieldsEnum.AVAILABLEONWEB}
              />
            ) : (
              <Typography variant="body2">
                No Rate Type Information Available
              </Typography>
            )}
          </Stack>
        </Stack>
      </Paper>
      <AlertComponent
        message={alertMessage}
        type={alertType}
        alertOpen={openAlert}
        closeAlert={() => setOpenAlert(false)}
      />
    </Stack>
  );
};
export default GolfRateTypes;
